var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2698 13.2906C14.9713 13.5777 14.4965 13.5684 14.2094 13.2698L10.5 9.33208L6.79062 13.2698C6.50353 13.5684 6.02875 13.5777 5.73017 13.2906C5.43159 13.0035 5.42228 12.5287 5.70937 12.2302L9.95937 7.73017C10.1008 7.58311 10.296 7.5 10.5 7.5C10.704 7.5 10.8992 7.58311 11.0406 7.73017L15.2906 12.2302C15.5777 12.5287 15.5684 13.0035 15.2698 13.2906Z",
    fill: "#96999E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.2713fc1fefd31b17529ade6b3717234b.svg";
export { ForwardRef as ReactComponent };